import React from 'react';
import { CircularProgress, Box, Typography, Stack } from '@mui/material';

interface SpinnerOverlayProps {
  loaderText?: string;
  showSpinner?: boolean;
  backgroundColor?: string; // New prop for background color
  textColor?: string; // New prop for text color
}

const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({ loaderText = 'Loading...', showSpinner = true, backgroundColor = 'rgba(0, 0, 0, 0.5)', textColor = 'white' }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: backgroundColor, // Use the provided background color
        flexDirection: 'column',
        zIndex: 1300, // Ensure it overlays other elements
      }}
    >
      {showSpinner && (
        <Box component={'div'}>
          <CircularProgress />
        </Box>
      )}
      <Box component={'div'} textAlign="center">
        <Typography variant="h6" color={textColor} sx={{ mt: 2 }}>
          {loaderText}
        </Typography>
      </Box>
    </Box>
  );
};

export const SpinnerSectionLoader: React.FC<SpinnerOverlayProps> = ({ loaderText = 'Loading...', showSpinner = true }) => (
  <Stack direction="column" alignItems="center" justifyContent="center" spacing={2} sx={{ width: '100%' }}>
    {showSpinner && (
      <Box sx={{ my: 2, height: '200px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>)}
    <Box sx={{ my: 2, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {loaderText}
    </Box>
  </Stack>
);

export default SpinnerOverlay;
